import React, { useCallback, useRef } from 'react';
import { RemovePromoIcon } from '../../../Icons';
import { ModalRef } from '../../../Modal/Modal';
import { PromoDetailsModal } from '../PromoDetailsModal/PromoDetailsModal';
import { PromoBanner } from '../../../../models';

import './PromoElement.css';
import { Config } from '../../../../helpers/config';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../../routes/types';
import {
  getFromLocalStorage,
  setOnLocalStorage,
  StorageKey,
} from '../../../../helpers/localstorage';

type PromoElementProps = {
  promoBanner: PromoBanner;
  onBannerRemoved: () => void;
};

export const PromoElement: React.FC<PromoElementProps> = ({ promoBanner, onBannerRemoved }) => {
  const history = useHistory();
  const promoDetailsModalRef = useRef<ModalRef>(null);

  const openModal = useCallback(() => {
    promoDetailsModalRef.current?.openModal();
  }, []);

  const goToLink = useCallback(() => {
    promoDetailsModalRef.current?.closeModal();
    history.push(
      Routes.NewsDetails.replace(':newsId', `${promoBanner.article.id}`)
    );
  }, [history, promoBanner.article.id]);

  const removePromoBanner = useCallback(() => {
    const promoBanners: string[] = getFromLocalStorage(
      StorageKey.RemovedPromoBanners
    );
    setOnLocalStorage(
      promoBanners ? [...promoBanners, promoBanner.id] : [promoBanner.id],
      StorageKey.RemovedPromoBanners
    );
    onBannerRemoved();
  }, [onBannerRemoved, promoBanner.id]);
  function prefixImageUrlIfNecessary(url = '') {
    return url.startsWith('https://') || url.startsWith('http://')
      ? url
      : `${Config.baseCmsUrl}${url}`;
  }
  return (
    <>
      <div className="promo-element--card" onClick={openModal}>
        <img
          className="promo-element--image"
          src={`${prefixImageUrlIfNecessary(promoBanner.image.url)}`}
        />
        <div className="promo-element--text-container">
          <h3 className="promo-element--title">{promoBanner.title}</h3>
          <p className="promo-element--description">
            {promoBanner.description}
          </p>
        </div>
        <button
          onClick={removePromoBanner}
          className="promo-element--remove-button"
        >
          <RemovePromoIcon />
        </button>
      </div>
      <PromoDetailsModal
        image={`${promoBanner?.largeImage?.url ? prefixImageUrlIfNecessary(promoBanner.largeImage.url) : prefixImageUrlIfNecessary(promoBanner.image.url)}`}
        title={promoBanner.title}
        description={promoBanner.description}
        ctaLabel="Vai all'articolo"
        onCtaClick={goToLink}
        ref={promoDetailsModalRef}
      />
    </>
  );
};
